import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import { CreditCardIssuer } from 'Jsx/CheckoutV4/types';

const getCreditCardCVC = ({
  eventInput,
  creditCardIssuer,
}: {
  eventInput: React.ChangeEvent<HTMLInputElement>;
  creditCardIssuer?: string;
}): {
  creditCardCVV: string;
  isCreditCardCVVValid: boolean;
  creditCardCVVErrorMessage: string;
  creditCardCVVDigits: number;
} => {
  const { value } = eventInput.target;
  const amexCvvDigits = 4;
  const otherCardsCvvDigits = 3;
  const creditCardCVVDigits =
    creditCardIssuer === CreditCardIssuer.AMEX
      ? amexCvvDigits
      : otherCardsCvvDigits;

  const creditCardCVV = value.replace(/\D|\s/g, '');

  const isCreditCardCVVValid =
    value.length > 2 && value.length === creditCardCVVDigits;

  return {
    creditCardCVV,
    isCreditCardCVVValid,
    creditCardCVVErrorMessage: '',
    creditCardCVVDigits,
  };
};

export default getCreditCardCVC;

export const validateCreditCardCVC = ({
  eventInput,
  creditCardIssuer,
}: {
  eventInput: React.ChangeEvent<HTMLInputElement>;
  creditCardIssuer?: string;
}): {
  creditCardCVVErrorMessage: string;
  isCreditCardCVVValid: boolean;
  creditCardCVV: string;
  creditCardCVVDigits: number;
} => {
  const {
    creditCardCVV,
    isCreditCardCVVValid,
    creditCardCVVErrorMessage,
    creditCardCVVDigits,
  } = getCreditCardCVC({ eventInput, creditCardIssuer });
  let errorMessage = creditCardCVVErrorMessage;

  if (creditCardCVV === '') {
    errorMessage = I18N_STRINGS.REQUIRED_CVC_CVV;
  } else if (!isCreditCardCVVValid) {
    errorMessage = I18N_STRINGS.INVALID_CVC_CVV;
  }

  return {
    creditCardCVVErrorMessage: errorMessage,
    isCreditCardCVVValid,
    creditCardCVV,
    creditCardCVVDigits,
  };
};
